import React from 'react';
import { get } from 'lodash';

import ImageLoader from './ImageLoader';

const UserAvatar = ({
  user
}) => {

  return (
    <div className='UserAvatar'>
      <div className='ImageBorder'>
        <ImageLoader url={get(user, 'profileIconThumbnail')} />
      </div>
      <p className='UserAvatar__nickname'>{get(user, 'nickname')}</p>
    </div>
    )
  }

  export default UserAvatar
